import React, { useEffect } from "react";
import TermsText from "presentational/termsAndPrivacy/TermsText";
import PrivacyText from "presentational/termsAndPrivacy/PrivacyText";
import { useHistory } from "react-router-dom";
import { withStore } from "store/storeHandler";
import TextButtonView from "presentational/common/TextButtonView";
import { getEssentialUrl } from "lib/urlQueryParser";
import PropTypes from "prop-types";

const languageButtonText = {
  terms: {
    en: "Terms of Use(English)",
    ko: "Terms of Use(Korean, 한국어)"
  },
  privacy: {
    en: "Privacy Policy(English)",
    ko: "Privacy Policy(Korean, 한국어)"
  }
};

TermsAndPrivacyPanel.propTypes = {
  type: PropTypes.oneOf(["terms", "privacy"]).isRequired,
  language: PropTypes.string
};

function TermsAndPrivacyPanel(props) {
  const { type, language, viewerLocation } = props;

  const history = useHistory();

  useEffect(() => {
    switch (language) {
      case "ko":
      case "en":
        break;
      default:
        const nextLanguage = viewerLocation === "KR" ? "ko" : "en";
        history.replace(getUrl(nextLanguage));
        break;
    }
  }, []);

  const getUrl = targetLanguage => {
    switch (type) {
      case "terms":
        return getEssentialUrl({ type: "terms" })(targetLanguage);
      case "privacy":
        return getEssentialUrl({ type: "privacy" })(targetLanguage);
      default:
        console.error("wrong type", type);
        break;
    }
  };

  const handleLangBtnClick = targetLanguage => () => {
    history.replace(getUrl(targetLanguage));
  };

  const getLanguageChangeBtnArea = () => {
    const targetLanguage = language === "ko" ? "en" : "ko";

    const func = handleLangBtnClick(targetLanguage);
    const btnText = languageButtonText[type][targetLanguage];

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 20
        }}
      >
        <TextButtonView onClick={func}>
          <span style={{ textDecoration: "underline" }}>{btnText}</span>
        </TextButtonView>
      </div>
    );
  };

  const getTextArea = () => {
    switch (type) {
      case "terms":
        return <TermsText language={language} />;
      case "privacy":
        return <PrivacyText language={language} />;
      default:
        console.error("wrong type", type);
        break;
    }
  };

  if (!(language === "ko" || language === "en")) return null;

  return (
    <div>
      {getLanguageChangeBtnArea()}
      {getTextArea()}
    </div>
  );
}

export default withStore({
  stateMap: {
    userDevice: ["viewerLocation"]
  }
})(TermsAndPrivacyPanel);
